interface TypeofResults {
	string: string;
	number: number;
	bigint: bigint;
	boolean: boolean;
	symbol: symbol;
	undefined: undefined;
	object: object | null;
	function: Function;
}

/**
 * Check whether a value is of a certain type
 * @function isOfType
 * @since v1.0.0
 * @implements {TypeofResults}
 * @param {unknown} value value to check type of
 * @param {K} type type to compare value to
 * @returns {boolean} true if value is of the specified type, otherwise false
 * @version v1.0.0
 * @public
 * @example
 * isOfType("Hello World", "string")
 * // true
 * @example
 * isOfType("Hello World", "number")
 * // false
 * @example
 * isOfType(4, "string")
 * // false
 * @example
 * isOfType(4, "number")
 * // true
 */
export const isOfType = <K extends keyof TypeofResults>(
	value: unknown,
	type: K
): value is TypeofResults[K] => typeof value === type;
